<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspLoadReport
          :company="company"
          :dateFrom="dateFrom"
          :dateTo="dateTo"
          :inspLoadListHeaders="inspLoadListHeaders"
          :inspLoadList="inspLoadList"
          :weekHeader="weekHeader"
          :chartList="chartList"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspLoadReport from '@/components/organisms/report/print/InspLoadReport'

export default {
  name: 'InspLoadPageReport',
  components: { InspLoadReport },
  props: {
    company: {
      type: String,
      required: true,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    },
    inspLoadListHeaders: {
      type: Array,
      required: true,
    },
    inspLoadList: {
      type: Array,
      required: true,
    },
    weekHeader: {
      type: Array,
      required: true,
    },
    chartList: {
      type: Array,
      required: false,
    },
  },
}
</script>
